const INTERESTING_YEAR = 2021;

function getAmountByYear(yearArray, year){
  const needle = yearArray.find(item => item.year === year);
  if (typeof needle !== 'undefined'){
    return needle['amount'];
  }else{
    return null
  }
}

function getInterestingYear(rawDataset){
  /* Definition/Claim/Algorithm */
  /* We are interested in the year of the last submitted report */
  /* We are interested in the year of the last submitted report that includes SALW data */
  /* We are interested in the year of the last submitted report by a trading partner that includes SALW trades with this country */
  /* Todo: Implementation !!  */
  return INTERESTING_YEAR
}

function filterTowEntryByYear(towEntry, interestingYear){
  const formattedTowEntry = {
    typeOfWeaponCode: towEntry['tow'],
    typeOfWeaponVerbose: towEntry['tow_verbose'], /* fix! */
    amountReportedByCountry: getAmountByYear(towEntry['own_values'], interestingYear),
    amountReportedByOthers: getAmountByYear(towEntry['other_values'], interestingYear)
  }
  return formattedTowEntry;
}

function formatDataset(rawDataset, interestingYear){
  const formattedDataset = rawDataset.map( (towEntry) => filterTowEntryByYear(towEntry, interestingYear) );
  return formattedDataset;
}

export function parseUnrocaData(rawData){
  const interestingYear = getInterestingYear(rawData);
  const smallArmsImports = rawData['sa_imp_time'];
  const lightWeaponsImports = rawData['lw_imp_time'];
  const smallArmsExports = rawData['sa_exp_time'];
  const lightWeaponsExports = rawData['lw_exp_time'];

  const unrocaSalwDatasets = [
    {
      "topicName": "Small Arms Imports",
      "topicData": formatDataset(smallArmsImports, interestingYear)
    },
    {
      "topicName": "Light Weapons Imports",
      "topicData": formatDataset(lightWeaponsImports, interestingYear)
    },
    {
      "topicName": "Small Arms Exports",
      "topicData": formatDataset(smallArmsExports, interestingYear)
    },
    {
      "topicName": "Light Weapons Exports",
      "topicData": formatDataset(lightWeaponsExports, interestingYear)
    }
  ];

  const returnObject = {
    year: interestingYear,
    datasets: unrocaSalwDatasets
  }

  return returnObject;
}



// WEBPACK FOOTER //
// ./src/helpers/parse-unroca-data.js